import { DATE_FORMAT } from 'src/utils/constants';
import { parseInStoredTimezone } from 'src/utils/timezoneUtils';

export const getDraftTransactionDateRange = ({
  isExternal,
  appliedDateRange,
  now
}) => {
  const defaultStartDateTime = isExternal ? null : now.clone().subtract(1, 'hour');
  const defaultEndDateTime = isExternal ? null : now;

  return {
    start: appliedDateRange.start
      ? parseInStoredTimezone(appliedDateRange.start, DATE_FORMAT.unixDateTime)
      : defaultStartDateTime,
    end: appliedDateRange.end
      ? parseInStoredTimezone(appliedDateRange.end, DATE_FORMAT.unixDateTime)
      : defaultEndDateTime
  };
};

const getActiveTransactionFilters = ({
  isIssued,
  isInward,
  site,
  tank,
  start,
  end
}) => {
  const filters = [];
  if (site && site !== 'all') filters.push({ key: 'site', label: 'Site', value: site });
  if ((isIssued || isInward) && tank && tank !== 'all') filters.push({ key: 'tank', label: 'Tank', value: tank });
  if (start || end) filters.push({ key: 'date', label: 'Date', value: start && end ? `${start} - ${end}` : start || end });
  return filters;
};

const SEARCH_FILTER_LABELS = {
  vehicle_number: 'Vehicle Number',
  vehicle_category: 'Vehicle Category',
  address: 'Dispenser Address',
  site_name: 'Site Name',
  invoice_number: 'Invoice Number',
  received_tank: 'Received Tank',
  card_num_1: 'Vehicle Card',
  dispenser: 'Dispenser'
};

export const getActiveTransactionSearchFilters = ({
  multiSearch = {},
  legacySearch = ''
}) => {
  const filters = Object.entries(multiSearch)
    .filter(([, value]) => String(value || '').trim())
    .map(([key, value]) => ({
      key,
      label: SEARCH_FILTER_LABELS[key] || key,
      value: String(value).trim()
    }));

  if (String(legacySearch || '').trim()) {
    filters.unshift({ key: 'legacy_search', label: 'Search', value: String(legacySearch).trim() });
  }
  return filters;
};

export default getActiveTransactionFilters;
